var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 9.472C14.6131 9.472 16.7376 7.34748 16.7376 4.736C16.7376 2.12453 14.6131 0 12.0016 0C9.39015 0 7.26562 2.12453 7.26562 4.736C7.26562 7.34748 9.39015 9.472 12.0016 9.472Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.356 11.7671C18.354 11.7665 18.3501 11.765 18.3481 11.7645C17.7314 11.6139 15.8431 11.3497 15.8431 11.3497C15.6299 11.2841 15.4021 11.397 15.3254 11.6074L12.4831 19.4061C12.3191 19.8559 11.6829 19.8559 11.5189 19.4061L8.67655 11.6074C8.61465 11.4375 8.45433 11.331 8.28253 11.331C8.2418 11.331 6.30023 11.6032 5.65384 11.764C3.88754 12.2032 2.77344 13.94 2.77344 15.7501V22.2392C2.77344 23.2116 3.5618 24 4.53425 24H19.4661C20.4386 24 21.2269 23.2116 21.2269 22.2392V15.7286C21.2269 13.9263 20.0691 12.3269 18.356 11.7671Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0729 11.201C12.9594 11.0774 12.7936 11.0153 12.6259 11.0153H11.3745C11.2068 11.0153 11.0409 11.0775 10.9275 11.201C10.7519 11.3924 10.7264 11.6688 10.8511 11.8848L11.52 12.8932L11.2069 15.5349L11.8235 17.1753C11.8836 17.3403 12.1169 17.3403 12.177 17.1753L12.7937 15.5349L12.4806 12.8932L13.1495 11.8848C13.274 11.6688 13.2485 11.3924 13.0729 11.201Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/manager.d00872b84eecec28a4f09ade7acdf5e9.svg";
export { ForwardRef as ReactComponent };